"use strict";

exports.__esModule = true;
exports.ActionButtonFields = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _reactDebounceInput = require("react-debounce-input");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _Core = require("../../Core");
var _UserActions = require("../../UserActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
_UserActions.UserActionSelector;

/**
 * Fields for DescriptionElement.
 */
var ActionButtonFields = exports.ActionButtonFields = function ActionButtonFields(props) {
  var path = props.path,
    elementEditor = props.elementEditor,
    element = props.element;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("ActionButtonFields.label", "Change User Action")
  }, /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.ElementActionControlGroup, {
    controlPaths: {
      onClickAction: path
    },
    elementEditor: elementEditor
  }), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: "Action Label"
  }, /*#__PURE__*/_react["default"].createElement(_reactDebounceInput.DebounceInput, {
    element: _core.InputGroup,
    minLength: 2,
    debounceTimeout: 300,
    value: element.props.label || "",
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "label", e.target.value);
    }
  })));
};